import { ENROLL_CONTEST_FIRST_NAME_CHANGED, ENROLL_CONTEST_LAST_NAME_CHANGED, ENROLL_CONTEST_PHONE_CHANGED, ENROLL_CONTEST_EMAIL_CHANGED, ENROLL_CONTEST_PROVINCE_CHANGED, ENROLL_CONTEST_CITY_CHANGED, ENROLL_CONTEST_CONTEST_CHANGED, ENROLL_CONTEST_COUNTRY_CHANGED, ENROLL_CONTEST_ABOUT_YOURSELF_CHANGED, ENROLL_CONTEST_TILL_WHEN_CHANGED, ENROLL_CONTEST_PROFILE_IMAGE_CHANGED, ENROLL_CONTEST_REQUEST, ENROLL_CONTEST_REQUEST_SUCCESS, ENROLL_CONTEST_ENROLLED_CONTESTS, ENROLL_CONTEST_GET_ENROLLED_CONTESTS, ENROLL_CONTEST_GET_ENROLLED_CONTESTS_SUCCESS, ENROLL_CONTEST_REMOVE_ENROLLED_CONTESTS, ENROLL_CONTEST_GENDER_CHANGED, ENROLL_CONTEST_FILL_USER_DATA, ENROLL_CONTEST_NOT_FOR_ME, GET_CONTEST_LIST, GET_CONTEST_LIST_SUCCESS, ENROLL_CONTEST_COUNTRY_CODE_CHANGED, GIVE_VOTE_SUCCESS, GIVE_VOTE, GIVE_VOTE_SUCCESS_EXPLORE, GIVE_VOTE_SUCCESS_FEATURE_VIDEO, GIVE_VOTE_SUCCESS_CONTEST_DETAILS } from "../constants/actionTypes";

export const enrollContestFirstNameChanged = payload => ({
    type: ENROLL_CONTEST_FIRST_NAME_CHANGED,
    payload:payload
});

export const enrollContestLastNameChanged = payload => ({
    type: ENROLL_CONTEST_LAST_NAME_CHANGED,
    payload:payload
});

export const enrollContestPhoneChanged = payload => ({
    type: ENROLL_CONTEST_PHONE_CHANGED,
    payload:payload
});

export const enrollContestCountryCodeChanged = payload => ({
    type: ENROLL_CONTEST_COUNTRY_CODE_CHANGED,
    payload:payload
});

export const enrollContestEmailChanged = payload => ({
    type: ENROLL_CONTEST_EMAIL_CHANGED,
    payload:payload
});

export const enrollContestProvinceChanged = payload => ({
    type: ENROLL_CONTEST_PROVINCE_CHANGED,
    payload:payload
});

export const enrollContestGenderChanged = payload => ({
    type: ENROLL_CONTEST_GENDER_CHANGED,
    payload:payload
});

export const enrollContestCityChanged = payload => ({
    type: ENROLL_CONTEST_CITY_CHANGED,
    payload:payload
});

export const enrollContestContestChanged = payload => ({
    type: ENROLL_CONTEST_CONTEST_CHANGED,
    payload:payload
});

export const enrollContestCountryChanged = payload => ({
    type: ENROLL_CONTEST_COUNTRY_CHANGED,
    payload:payload
});

export const enrollContestAboutYourselfChanged = payload => ({
    type: ENROLL_CONTEST_ABOUT_YOURSELF_CHANGED,
    payload:payload
});

export const enrollContestTillWhenChanged = payload => ({
    type: ENROLL_CONTEST_TILL_WHEN_CHANGED,
    payload:payload
});

export const enrollContestProfileImageChanged = payload => ({
    type: ENROLL_CONTEST_PROFILE_IMAGE_CHANGED,
    payload:payload
});

export const enrollContestRequest = payload => ({
    type: ENROLL_CONTEST_REQUEST,
    payload:payload
});

export const enrollContestRequestSuccess = payload => ({
    type: ENROLL_CONTEST_REQUEST_SUCCESS,
    payload:payload
});

export const getEnrolledContests = () => ({
    type: ENROLL_CONTEST_GET_ENROLLED_CONTESTS
});

export const getEnrolledContestsSuccess = payload => ({
    type: ENROLL_CONTEST_GET_ENROLLED_CONTESTS_SUCCESS,
    payload:payload
});

export const removeEnrolledContests = payload => ({
    type: ENROLL_CONTEST_REMOVE_ENROLLED_CONTESTS,
    payload:payload
});

export const fillUserData = payload => ({
    type: ENROLL_CONTEST_FILL_USER_DATA,
    payload
});

export const enrollContestNotForMe = payload => ({
    type: ENROLL_CONTEST_NOT_FOR_ME,
    payload
});

export const getContestList = () => ({
    type: GET_CONTEST_LIST
});

export const getContestListSuccess = payload => ({
    type: GET_CONTEST_LIST_SUCCESS,
    payload
});

export const giveVote = payload => ({
    type: GIVE_VOTE,
    payload
});

export const giveVoteSuccess = payload => ({
    type: GIVE_VOTE_SUCCESS,
    payload
});

export const giveVoteSuccessExplore = payload => ({
    type: GIVE_VOTE_SUCCESS_EXPLORE,
    payload
});

export const giveVoteSuccessFeatureVideo = payload => ({
    type: GIVE_VOTE_SUCCESS_FEATURE_VIDEO,
    payload
});

export const giveVoteSuccessContestDetails = payload => ({
    type: GIVE_VOTE_SUCCESS_CONTEST_DETAILS,
    payload
});